{
	"id": 7819577,
	"numericId": 7819577,
	"collectionId": 787,
	"status": "ACTIVE",
	"sessionTime": 0,
	"startTime": "2026-05-20T06:08:40.381Z",
	"examBreak": null,
	"timeAllocation": null,
	"progressList": [],
	"sessionItems": [
		{
			"id": 103705,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"overview": {
					"title": "The Professional Educator and the Community",
					"summary": "This module contains two activities and a five-question end-of-module knowledge check. It will take approximately 30 to 40 minutes to complete the entire module.",
					"moduleNumber": 5,
					"activityCount": 2,
					"knowledgeCheckCount": 5,
					"estimatedDurationMinutes": 35
				},
				"moduleOutline": {
					"heading": "Module Outline",
					"sections": [
						{
							"items": [
								{
									"icon": "circle-play",
									"title": "Video"
								},
								{
									"icon": "messages-square",
									"title": "Perspectives"
								},
								{
									"icon": "square-pen",
									"title": "Reflect"
								},
								{
									"icon": "compass",
									"title": "Explore"
								},
								{
									"icon": "clipboard-check",
									"title": "Review"
								},
								{
									"icon": "chart-column-increasing",
									"title": "Analysis"
								}
							],
							"title": "Scenario: Social Gathering"
						},
						{
							"title": "Ethical Situations: What Action Is Appropriate"
						},
						{
							"title": "Module 5 Summary"
						}
					]
				},
				"learningObjectives": {
					"heading": "Learning Objectives",
					"objectives": [
						"Analyzing a scenario to differentiate how dispositional and regulatory frameworks influence decision making and determining an appropriate course of action",
						"Evaluating competing ethical tensions to select actions aligned with ethical principles",
						"Applying decision criteria aligned to the *Model Code of Ethics for Educators* (*MCEE*) to resolve ethical scenarios"
					]
				}
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "module_intro",
				"language": "en-US",
				"position": 1,
				"sourceId": 5010
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37091,
					"label": "Module 5: The Professional Educator and the Community",
					"title": "Module 5: The Professional Educator and the Community",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103706,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will consider a scenario involving ethical decisions that educators encounter in everyday situations.\n\nFirst, you will review a video that shows a group of educators interacting with one another. Then, you will gain further insight by reviewing two videos showing the perspectives of people involved in the scenario. After observing the videos, you will reflect on and explore the ethical dilemmas depicted in the scenario.",
				"media": [
					{
						"type": "VIDEO",
						"title": "Social Gathering",
						"videoUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-5/m5_scenario.mp4",
						"transcript": "**Teachers’ Discussion in a Restaurant**\n\nThe video shows a busy restaurant. Four teachers sit together at a table with pizza and drinks. A woman is seated nearby, close enough to hear the teachers’ conversation.\n\nWaitress: Here’s your pepperoni, hot and fresh. Do you need anything else right now?\n\nMs. Garcia: This looks amazing, thank you.\n\nCoach Wong: Wow, this place is packed. Anyone want to order another pitcher before the game?\n\nMs. Harris: Sure, why not?\n\nMs. Garcia: Long week, feels good to unwind. [All four teachers laugh.]\n\nMs. Harris: Glad you finally joined us, Mr. Anderson, but a little pizza before a Friday game is well earned. [All four teachers laugh.]\n\nMr. Anderson: Yeah, thanks for inviting me. It was a busy week keeping the social studies department running. [All four teachers laugh.]\n\nCoach Wong: Hey, did you all hear the rumor? [The woman seated nearby is looking at the teachers and seems to be listening to their conversation.] I heard that Ms. Hernandez, the special education teacher, is getting sent to another school in the district. [The other three teachers look concerned.] Honestly, she never seems to keep a close eye on the students with special needs, does she?\n\n[The woman nearby reacts apprehensively to this. Mr. Anderson looks uncomfortable and shifts in his seat.]\n\nMs. Garcia: Speaking of support, Jada has been skipping her assignments again. [The woman nearby seems negatively affected by the teachers’ conversation.] I know she has accommodations, but I can’t keep chasing her down every day. It feels like she’s heading for real trouble.\n\nMs. Harris: You’re not kidding, I feel like every week there’s another new rule or form for the special education students. [The woman nearby reacts to this and keeps listening to the teachers’ conversation.] Don’t get me wrong, I want to support them, but keeping up with all those regulations feels impossible sometimes. [Mr. Anderson glances down and looks uncomfortable with the conversation.] Isn’t that a parent over there?\n\nCoach Wong: Oh, that’s Ms. Lewis, right? [The woman nearby walks to the exit, avoiding eye contact with the teachers.] Do any of you have her kids this year? [The teachers look down and do not respond verbally to the question.] Anyway, game starts earlier tonight. We should get moving soon.",
						"transcriptTitle": "Transcript for Social Gathering video",
						"transcriptInstruction": "**Directions:** Select the following expandable text button to access the transcript of the video."
					}
				],
				"title": "Scenario: Social Gathering",
				"instruction": "**Directions:** Review the following video to learn about the scenario. Select the play button to begin. Use the video controls when needed."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_presentation",
				"language": "en-US",
				"position": 2,
				"sourceId": 5020
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37091,
					"label": "Module 5: The Professional Educator and the Community",
					"title": "Module 5: The Professional Educator and the Community",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103707,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of nine situations that require you to choose from two alternate responses to the situation. After each situation, you will be presented with two flip cards that describe a response to the situation. Take a moment to consider the ethical implications and think about how you would handle each situation.",
				"title": "Ethical Situations: What Action Is Appropriate?",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Try again. The fact that a student has an IEP and the nature of the assistance that a student with a disability may need are confidential. That information should not be shared with another family or student. The school’s special education resources are a better, and more appropriate, place to start."
							},
							"front": {
								"text": "Talk with the parents of a student who is excelling in math. Explain to them that there is a student with an IEP who requires help and arrange for collaboration between the two students."
							},
							"label": "Option 1"
						},
						{
							"id": "B",
							"back": {
								"text": "Good job. The special education teacher and educators with specializations, like counselors or therapists, can best assist with how to integrate collaborative learning techniques to help this student. But collaborative methods should not reveal the student’s confidential information related to their IEP."
							},
							"front": {
								"text": "Coordinate with the special education teacher on how best to integrate accommodations for this student into his classroom teaching. Calvin should also confer with the special education teacher on effective ways to use collaborative learning techniques in the classroom."
							},
							"label": "Option 2"
						}
					],
					"count": 9,
					"setup": "Calvin, a fifth-grade teacher, is trying to find ways to help a student with a documented learning disability who is struggling with math.",
					"title": "Situation 1: Handling Confidential Information",
					"number": 1,
					"prompt": "What should Calvin do?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following two flip cards to learn about the possible options for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 8,
				"sourceId": 5080
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37091,
					"label": "Module 5: The Professional Educator and the Community",
					"title": "Module 5: The Professional Educator and the Community",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103708,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "The first step in navigating ethical dilemmas is to understand how your values and dispositions can affect your decisions. Educators’ decisions are influenced by two frameworks: dispositional and regulatory. The influence of each framework varies, and educators can be influenced more strongly by one framework than by another. Reflect on what influenced Coach Wong, Mr. Anderson, and Ms. Garcia’s decisions.",
				"title": "Scenario: Reflect",
				"question": "Were Coach Wong, Mr. Anderson, and Ms. Garcia initially influenced more by their dispositional framework or the regulatory framework?",
				"instruction": "**Directions:** Select each of the following two frameworks to read its definition. Then answer the question by choosing one of the frameworks and selecting Submit. If needed, you can try again and select the alternative framework to reveal the explanation."
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "scenario_reflect_framework_choice",
				"language": "en-US",
				"position": 4,
				"sourceId": 5040
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "07d0dbb1-33d0-4d70-8a8b-bbaef036708f",
						"isCorrect": true
					},
					{
						"choiceId": "2b130481-6e7d-4b0c-96b5-a52f6a850428",
						"isCorrect": false
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "07d0dbb1-33d0-4d70-8a8b-bbaef036708f",
					"detailed": {
						"text": "Coach Wong, Mr. Anderson, and Ms. Garcia were primarily influenced by their dispositional framework. Coach Wong’s behavior is largely driven by comfort, familiarity, and casual norms, rather than professional obligations. Ms. Garcia prioritized her desire to socialize at dinner over her professional responsibility to maintain student confidentiality. Mr. Anderson wanted to belong and avoid conflict, which overrode his regulatory instincts and led him to question his silence."
					},
					"language": "en-US"
				},
				{
					"type": "STATIC",
					"choiceId": "2b130481-6e7d-4b0c-96b5-a52f6a850428",
					"detailed": {
						"text": "If the regulatory framework had been their dominant guide, the educators would have recognized that discussing a student’s accommodations and academic struggles in a public setting was ill-advised and they would not have talked about the student. Instead, they acted as if such guidelines were distant or secondary, allowing the conversation to unfold casually despite crossing clear professional boundaries."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "07d0dbb1-33d0-4d70-8a8b-bbaef036708f",
						"icon": "heart-handshake",
						"text": "Influenced More by Dispositional Framework",
						"description": "The personal and professional attitudes, values, and beliefs that inform a professional educator’s decision making.",
						"numFirstSelections": 0
					},
					{
						"id": "2b130481-6e7d-4b0c-96b5-a52f6a850428",
						"icon": "scale",
						"text": "Influenced More by Regulatory Framework",
						"description": "School or district policies, state statutes, and criminal laws that form the basis for conduct absolutes and inform a professional educator’s decision making.",
						"numFirstSelections": 0
					}
				],
				"shuffle": false
			},
			"tags": [
				{
					"id": 37091,
					"label": "Module 5: The Professional Educator and the Community",
					"title": "Module 5: The Professional Educator and the Community",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103709,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of nine situations that require you to choose from two alternate responses to the situation. After each situation, you will be presented with two flip cards that describe a response to the situation. Take a moment to consider the ethical implications and think about how you would handle each situation.",
				"title": "Ethical Situations: What Action Is Appropriate?",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Try again. This arrangement raises ethical concerns, and the offer could be considered a commission or bribe. Gunnar should follow his district’s rules, seek permission, disclose the arrangement to students’ families, and use any benefits to lower costs for all travelers."
							},
							"front": {
								"text": "Accept the offer without further steps."
							},
							"label": "Option 1"
						},
						{
							"id": "B",
							"back": {
								"text": "Good job. Gunnar must get approval from his district, be transparent with students’ families about the arrangement, and ensure any benefits reduce overall costs for all travelers, thereby upholding ethical standards."
							},
							"front": {
								"text": "Follow district policies and inform students’ families."
							},
							"label": "Option 2"
						}
					],
					"count": 9,
					"setup": "Gunnar is the German teacher at a high school. Every year he leads a trip to Germany for seniors and juniors. A travel company has offered to handle all the travel arrangements and bookings for Gunnar. Also, the company will pay for all his travel and give him an expense stipend that will increase for every student he brings on the trip.",
					"title": "Situation 8: Travel Expenses",
					"number": 8,
					"prompt": "What should Gunnar do?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following two flip cards to learn about the possible options for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 15,
				"sourceId": 5150
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37091,
					"label": "Module 5: The Professional Educator and the Community",
					"title": "Module 5: The Professional Educator and the Community",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103710,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "Gain further insight by reviewing the following two videos showing the perspectives of Mr. Anderson, Ms. Lewis, and Ms. Garcia.",
				"items": [
					{
						"media": {
							"type": "VIDEO",
							"videoUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-5/m5_perspective_mr_anderson.mp4",
							"transcript": "**Mr. Anderson’s Perspective**\n\nThe video shows Mr. Anderson reflecting on his discussion with the teachers at the restaurant. As he speaks, he is sitting in a classroom at a student desk and writing in a notebook.\n\nMr. Anderson: I know that information about students with disabilities and the services they receive is confidential. But at the restaurant, everyone was talking so casually. Rumors about a colleague. Comments about special education requirements. Personal details about Jada, right there in public. [Mr. Anderson sighs.] And I just sat there. [Mr. Anderson flips a page in the notebook.] I didn’t say anything. I liked being included, but staying silent didn’t feel right. I keep asking myself, should I have spoken up?",
							"transcriptTitle": "Transcript for Mr. Anderson video",
							"transcriptInstruction": "**Directions:** Select the following expandable text button to access the transcript of the video."
						},
						"title": "Mr. Anderson"
					},
					{
						"media": {
							"type": "VIDEO",
							"videoUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-5/m5_perspective_parent_email.mp4",
							"transcript": "**A Concern About Friday Night**\n\nThe video shows Ms. Garcia reading an email from Ms. Lewis titled “A Concern About Friday Night.” Ms. Lewis is not in the room but is narrating the email. The video switches back and forth between the laptop screen displaying the email and Ms. Garcia’s face as she reads the email. Throughout the video Ms. Garcia’s expression shows that she realizes that her actions were inappropriate.\n\nDear Ms. Garcia,\n\nI wanted to share something that has stayed with me since Friday night. I was seated near your table at the restaurant and overheard your conversation.\n\nWhen I heard a teacher at the table making comments about Ms. Hernandez, our special education teacher, it concerned me, especially since the information sounded like gossip.\n\nBut what affected me most was hearing my daughter, Jada, discussed in public...\n\nHer assignments, her support needs, and her challenges with special education services are private matters.\n\nJada works hard to manage her learning differences, and hearing her struggles talked about casually, in a crowded restaurant, was painful.\n\nI understand that teachers need to unwind after a long week, but student privacy is so important, especially for children with disabilities.\n\nI’m not angry, but I am disappointed and concerned. I hope this helps reinforce how easily trust between families and schools can be shaken and how important it is that conversations about students stay confidential.\n\nSincerely,\nMs. Lewis",
							"transcriptTitle": "Transcript for Parent Email video",
							"transcriptInstruction": "**Directions:** Select the following expandable text button to access the transcript of the video."
						},
						"title": "Parent Email"
					}
				],
				"title": "Scenario: Perspectives",
				"instruction": "**Directions:** Select each of the following two tabs to review the perspective videos. Select the play button in each tab to begin. Use the video controls when needed."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_perspective_resource_set",
				"language": "en-US",
				"position": 3,
				"sourceId": 5030
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37091,
					"label": "Module 5: The Professional Educator and the Community",
					"title": "Module 5: The Professional Educator and the Community",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103711,
			"versionId": 1,
			"blockId": null,
			"type": "SATA",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "The second step in navigating ethical dilemmas is exploring the risks to the ethical principles.",
				"title": "Scenario: Explore",
				"question": "Which of the following ethical principles were at immediate risk for Coach Wong, Mr. Anderson, and Ms. Garcia in the scenario? Select all that apply.",
				"instruction": "**Directions:** Select each of the following nine expandable text buttons to review information about each principle of ethical decision making.",
				"ethicalPrinciples": {
					"items": [
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-01-promoting-solution-discovery-illustration-v2.png"
								}
							],
							"title": "**P**romoting Solution Discovery",
							"description": "Creating opportunities for self-advocacy and problem resolution is a foundational principle in ethical decision making. Educators should refer students or colleagues to suitable school resources and officials and ensure that these students and colleagues follow up, rather than handle issues themselves. Not only is this in the best interest of those involved, but it also allows situations to be handled objectively and avoids blurring the scope of the educator’s position with that of more expansive roles such as those of counselor, confidant, caregiver, and rescuer. The primary role of the professional educator is most often associated with the tasks of teaching and learning.\n\n**Guiding Questions**\n- What are the inherent professional risks in attempting to fix the immediate or long-term challenges, problems, and obstacles that students, colleagues, or other learning community stakeholders encounter?\n- Am I accepting responsibilities, performing duties, or providing services that correspond with my training and area of certification?\n- How can I help colleagues when their role as a professional educator overlaps with other societal expectations?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-02-risk-mitigation-illustration-v2.png"
								}
							],
							"title": "**R**isk Mitigation",
							"description": "Since educators provide services directly to minors who remain under their care and supervision for extended periods of time without the presence of parents or guardians, the field of education has many professional risks and vulnerabilities. It is important that all educators continually reflect on how to best mitigate risks that may compromise their professional and personal credibility, career goals, personal well-being, and effectiveness as a teacher.\n\n**Guiding Questions**\n- How can a seemingly innocuous and insignificant decision have the potential to put my educational practice at risk?\n- What professional-risk situations inherent in my educational practice do I need to carefully consider (for example, chaperoning an overnight field trip, being approached by a student for personal advice)?\n- What conversations can I have with my colleagues to help identify ways to mitigate risks in situations that we commonly encounter?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-03-objectivity-neutrality-maintained-illustration-v3.png"
								}
							],
							"title": "**O**bjectivity and Neutrality Are Maintained",
							"description": "By maintaining objectivity and neutrality, professional educators should be able to evaluate a situation without emotional entanglements or bias. Remaining objective and neutral mitigates the risks of over-identifying with one party, becoming too focused on the needs of an individual, or advocating for a singular interest instead of advocating for solutions.\n\n**Guiding Questions**\n- When encountering competing tensions (for example, school policy versus what I think is best for a student or colleague; parental influence versus administrative influence), how can I determine the best course of action?\n- How can I remain objective and neutral when I have multiple relationships in the schooling community and as a community member (for example, I’m a friend of one of my student’s parents; I am a youth group leader at a student’s religious center; I coach a student on a club volleyball team during the summer)?\n- How can I best caution a colleague if I suspect the colleague is becoming overwhelmed by the needs of a student?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-04-ensuring-student-welfare-illustration-v2.png"
								}
							],
							"title": "**E**nsuring Student Welfare",
							"description": "Since the individuals receiving services are minors and the educators have been ascribed in loco parentis responsibilities, the primary responsibility of educators is to ensure the students’ safety and welfare. The scope of this charge is not just limited to physical safety, but it also includes emotional, intellectual, psychological, and sexual safety.\n\n**Guiding Questions**\n- Am I doing everything in my power to establish a safe and secure environment for academic, personal, and social growth to occur?\n- Am I willing to safeguard students from duress even if I am not directly responsible for the students?\n- How can I best confront a colleague regarding acts, either committed or omitted, that have the potential to compromise a student’s welfare?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-05-transparency-actions-communications-illustration-v2.png"
								}
							],
							"title": "**T**ransparency in Actions and Communications",
							"description": "Educators must be transparent in their actions and communications. Transparency establishes openness, accountability, trust, credibility, and boundaries. Failure to be sufficiently transparent with appropriate stakeholders (for example, parents, guardians, students, colleagues, administrators) may result in misinterpretation of motives or the appearance of impropriety. Transparency is the best way for educators to ensure that their decisions and behaviors can withstand public scrutiny.\n\n**Guiding Questions**\n- How can I ensure that all communications with students, including digital and electronic communications, are conducted with transparency?\n- How can I balance the need for transparency in my actions and communications with protecting highly confidential information that I am expected to retain (which is considered a “qualified privilege” by the courts)?\n- How do I best approach a colleague about rumors of impropriety that are a result of their lack of transparency in decision making?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-06-boundaries-role-time-place-illustration-v2.png"
								}
							],
							"title": "**H**onoring the Boundaries of Role, Time, and Place",
							"description": "Boundaries encompass the verbal, physical, emotional, and social distances that an educator must maintain to ensure security, structure, and predictability in an educational environment. Most often, the boundaries that are transgressed relate to role, time, and place. By respecting the functions and limits of contracted roles, as well as the working hours and location of the learning environment, secure boundaries are in place for all members of the school community.\n\n**Guiding Questions**\n- In reflecting on my educational practice, which dispositions most risk eroding professional boundaries (for example, assisting with students’ personal challenges, extending academic support beyond school hours, engaging in extracurricular activities, communication with students, parents, and colleagues)?\n- Am I thinking about all my interactions with students (for example, in the school, in the community, and at social functions) as an extension of my professional responsibilities as an educator?\n- How can my colleagues and I openly discuss and agree on boundaries that are most appropriate for our educational context?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-07-integrity-profession-illustration-v2.png"
								}
							],
							"title": "**I**ntegrity of the Profession Is Promoted by the Educator",
							"description": "Educators’ actions reflect on the schooling community, the district, and the profession. An individual educator’s positive actions have the potential to inspire public confidence in the profession. On the other hand, negative actions can cast shadows of doubt and distrust by undermining the effectiveness of a healthy educational structure. The professional educator has an obligation to hold himself or herself responsible for ethical conduct. The educator should take steps when he or she has reason to believe that another educator may be approaching or engaged in an ethically compromising situation.\n\n**Guiding Questions**\n- How often am I reflecting on the daily decisions that I make as a professional educator and how those decisions may affect the integrity of the profession?\n- What steps can I take when I believe that a colleague may be approaching or involved in an ethically compromising situation?\n- How can I best advocate for the profession while also working to reconcile points of disagreement within the school or district?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-08-code-ethics-fidelity-illustration-v2.png"
								}
							],
							"title": "**C**ode of Ethics for Educators Is Maintained with Fidelity",
							"description": "Having an ethics code is a proclamation that a profession is better off when ethical standards are not based solely on individual assessments of what is or is not ethically acceptable but reflect consensus among members on a common purpose. For the education discipline, the *Model Code of Ethics for Educators* (*MCEE*) is a guide for what educators should expect of themselves and one another and should be maintained with fidelity. The *MCEE* assists educators in their efforts to resolve ethical dilemmas and helps educators defend their decisions to schooling-community constituents, institutions, courts, and any other agency that would encourage them to go against the values of the profession. The formal standards are not a substitute for an active, deliberate, and creative approach to fulfilling your ethical responsibilities. They prompt, guide, and inform an educator’s ethical decision-making; they do not serve as a substitute for it.\n\n**Guiding Questions**\n- How can educators from my school or district work together to identify common ethical dilemmas that we encounter?\n- Is there a way to use the *MCEE* as a prompt to discuss resolutions to those ethical dilemmas?\n- Since ethical dilemmas are often situational, contextual, and likely to change over time, how can the *MCEE* continue to guide and inform my decision making as I engage in the practical realities of my work?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-09-stewardship-law-public-trust-illustration-v2.png"
								}
							],
							"title": "**S**tewardship of the Law and Public Trust",
							"description": "Employment policies, licensure statutes, and community laws represent conduct absolutes that have originated from a history of judicial activity. They represent the lowest standard of acceptable behavior deemed necessary to safeguard community members. However, the professional educator is aware that trust in the profession depends on a level of conduct and responsibility that may be higher than what is required by law.\n\n**Guiding Questions**\n- How will relevant procedures, policies, and laws inform my decision making when I encounter ethical dilemmas?\n- It has been said that misconduct is not an event but a process. Will I be able to identify those situations where a series of gradual and unintentional missteps could lead to the transgression of a conduct absolute?\n- What steps can I take when I believe that a colleague may be approaching or involved in actions that may lead to the transgression of a policy, statute, or law?"
						}
					],
					"title": "Ethical Principles"
				}
			},
			"metadata": {
				"type": "SATA",
				"ui_type": "scenario_principle_sata_activity",
				"language": "en-US",
				"position": 5,
				"sourceId": 5050
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "56c4cdd2-7398-4663-8fb6-69927a9116d2",
						"isCorrect": false
					},
					{
						"choiceId": "c4aa6d16-faa9-42e1-96e8-d6a777232f16",
						"isCorrect": false
					},
					{
						"choiceId": "0335c959-69fd-4eb8-b926-13a37e263ef3",
						"isCorrect": true
					},
					{
						"choiceId": "24daf2d6-6a20-4880-90f2-ef95b7538138",
						"isCorrect": true
					},
					{
						"choiceId": "54bf8c96-e773-48bf-bf6e-c646df65dbd9",
						"isCorrect": false
					},
					{
						"choiceId": "3d0b8a40-66f8-4954-8b49-da934ea5167b",
						"isCorrect": true
					},
					{
						"choiceId": "4087c5ad-4635-428b-8b17-29e3cf0a64b6",
						"isCorrect": true
					},
					{
						"choiceId": "0664c788-da45-467b-a113-55b39faae44f",
						"isCorrect": true
					},
					{
						"choiceId": "fba7645a-e72f-4489-a011-01d9e7aa7d1c",
						"isCorrect": true
					}
				],
				"selection": {
					"max": 9,
					"min": 1
				}
			},
			"feedback": null,
			"response": {
				"type": "MULTIPLE_SELECT",
				"choices": [
					{
						"id": "56c4cdd2-7398-4663-8fb6-69927a9116d2",
						"text": "Promoting Solution Discovery",
						"numFirstSelections": 0
					},
					{
						"id": "c4aa6d16-faa9-42e1-96e8-d6a777232f16",
						"text": "Risk Mitigation",
						"numFirstSelections": 0
					},
					{
						"id": "0335c959-69fd-4eb8-b926-13a37e263ef3",
						"text": "Objectivity and Neutrality Are Maintained",
						"numFirstSelections": 0
					},
					{
						"id": "24daf2d6-6a20-4880-90f2-ef95b7538138",
						"text": "Ensuring Student Welfare",
						"numFirstSelections": 0
					},
					{
						"id": "54bf8c96-e773-48bf-bf6e-c646df65dbd9",
						"text": "Transparency in Actions and Communications",
						"numFirstSelections": 0
					},
					{
						"id": "3d0b8a40-66f8-4954-8b49-da934ea5167b",
						"text": "Honoring the Boundaries of Role, Time, and Place",
						"numFirstSelections": 0
					},
					{
						"id": "4087c5ad-4635-428b-8b17-29e3cf0a64b6",
						"text": "Integrity of the Profession Is Promoted by the Educator",
						"numFirstSelections": 0
					},
					{
						"id": "0664c788-da45-467b-a113-55b39faae44f",
						"text": "Code of Ethics for Educators Is Maintained with Fidelity",
						"numFirstSelections": 0
					},
					{
						"id": "fba7645a-e72f-4489-a011-01d9e7aa7d1c",
						"text": "Stewardship of the Law and Public Trust",
						"numFirstSelections": 0
					}
				],
				"shuffle": false
			},
			"tags": [
				{
					"id": 37091,
					"label": "Module 5: The Professional Educator and the Community",
					"title": "Module 5: The Professional Educator and the Community",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103712,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "",
				"items": [
					{
						"media": [
							{
								"type": "IMAGE",
								"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-5/m5_ms_garcia.png"
							}
						],
						"title": "Ms. Garcia",
						"analysis": {
							"text": "Ms. Garcia casually discusses confidential information about Jada, a student with disabilities (for example, “Jada’s been skipping her assignments again. . . . I can’t keep chasing her down.”).\n\nIn a public restaurant, this constitutes a serious breach of confidentiality involving special education and FERPA-protected student information. Ms. Garcia has an open, friendly personality, and her desire to connect socially overrides her professional judgment.\n\nThis directly violates boundaries of time, place, and role for discussing a student’s special education needs.",
							"title": "Analysis"
						},
						"questions": {
							"text": "The following are reflective questions that Ms. Garcia could ask herself.\n- Would I share this same information if I knew that Jada or her parent were sitting next to me?\n- Is this conversation serving a professional purpose, or am I just venting in a casual setting?\n- Could this information allow others in this public setting to identify the student?\n- How might a parent feel when hearing their child’s challenges discussed casually over dinner?",
							"title": "Questions"
						},
						"keyTakeaway": {
							"text": "**Students’ private information, especially special education information, is never an appropriate topic for casual conversation.**\nAcademic struggles, accommodations, and special education details are legally protected. Ms. Garcia must reserve discussions about these topics for appropriate professional contexts and be mindful of tone and location. Confidentiality protects student dignity and the trust of families, even when teachers are “off the clock.”",
							"title": "Key Takeaway"
						}
					},
					{
						"media": [
							{
								"type": "IMAGE",
								"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-5/m5_coach_wong.png"
							}
						],
						"title": "Coach Wong",
						"analysis": {
							"text": "Coach Wong violates ethics in the following two ways.\n\n- **Spreading rumors about and disrespecting a colleague**\n\nHe says the following out loud in a public place:\n“I heard that Ms. Hernandez . . .  is getting sent to another school. . . . She never seems to keep a close eye on the students with special needs, does she?”\n\nThis behavior is unethical for the following reasons.\n\n- It is unprofessional.\n- It is based on rumor: He begins with “I heard. . . .”\n- It is disparaging toward a special education teacher.\n- It is done in public, damaging staff morale and the trust of the family.\n\n- **Normalizing harmful talk in front of colleagues**\n\nAs a socially influential peer, Coach Wong’s behavior lowers professional boundaries for everyone at the table.",
							"title": "Analysis"
						},
						"questions": {
							"text": "The following are reflective questions that Coach Wong could ask himself.\n- Is what I am saying based on fact and is it appropriate for me to share?\n- How would I feel if someone spoke about me or my work performance this way?\n- Is this comment respecting the professionalism of my colleague?\n- What message am I sending to others about how teachers discuss students and staff?",
							"title": "Questions"
						},
						"keyTakeaway": {
							"text": "**Educators must avoid spreading hearsay and must show professional respect, especially toward colleagues in specialized roles.**\nRumor sharing erodes school culture and public trust. As a coach and teacher, Coach Wong sets a tone, so modeling respect and discretion is essential for him. Refraining from gossiping protects colleagues and keeps the focus on students’ needs rather than on gossip.",
							"title": "Key Takeaway"
						}
					},
					{
						"media": [
							{
								"type": "IMAGE",
								"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-5/m5_mr_anderson.png"
							}
						],
						"title": "Mr. Anderson",
						"analysis": {
							"text": "As the head of the Social Studies Department, Mr. Anderson notices the following.\n- Confidential student information being shared\n- Special education issues being discussed inappropriately\n- Rumors being shared about Ms. Hernandez and colleagues disrespecting her\n- A parent, Ms. Lewis, overhearing\n\nHe feels responsible but does not intervene.\n\nMr. Anderson faces a common ethical dilemma. He must decide between doing nothing, or bystander inaction, and acting according to professional responsibility.",
							"title": "Analysis"
						},
						"questions": {
							"text": "The following are reflective questions that Mr. Anderson could ask himself.\n- What responsibility do I have as a department head to redirect this conversation?\n- What harm might come from staying silent in this moment?\n- What social skills could I use to gently shift the conversation back to a topic that respects our professional boundaries?\n- If anyone overhears our conversation, what message would it send about our school and our level of professionalism?",
							"title": "Questions"
						},
						"keyTakeaway": {
							"text": "**Silence is not a neutral reaction. Leaders have an ethical obligation to intervene when confidentiality is at risk.**\nMr. Anderson did not create the problem, but his role includes the responsibility to safeguard professional culture. Even a brief, calm redirect (for example, “Let’s not discuss student matters here.”) would promote professional standards. His intervention could prevent harm to families and support colleagues in staying aligned with ethical practices.",
							"title": "Key Takeaway"
						}
					}
				],
				"title": "Scenario: Analysis",
				"instruction": "**Directions:** Select each of the following three tabs to analyze the behavior of the educators involved. Select each of the expandable text buttons within each tab to review the information about each person."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_analysis_cards",
				"language": "en-US",
				"position": 7,
				"sourceId": 5070
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37091,
					"label": "Module 5: The Professional Educator and the Community",
					"title": "Module 5: The Professional Educator and the Community",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103713,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of nine situations that require you to choose from two alternate responses to the situation. After each situation, you will be presented with two flip cards that describe a response to the situation. Take a moment to consider the ethical implications and think about how you would handle each situation.",
				"title": "Ethical Situations: What Action Is Appropriate?",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Good job. Jane opts to buy her own supplies for making flyers, signs, and labels rather than using school resources, demonstrating integrity and upholding professional boundaries as an educator."
							},
							"front": {
								"text": "Use or obtain personal supplies only. Go to the nearest office supply store and buy printed-out flyers, markers to make signs, and blank stickers for writing the asking prices of the items she is selling."
							},
							"label": "Option 1"
						},
						{
							"id": "B",
							"back": {
								"text": "Try again. Jane could go to the school’s copy room to make flyers and take supplies, but doing so is inappropriate and risks her job and teaching license. Using school resources for personal benefit can have serious professional consequences, regardless of intentions."
							},
							"front": {
								"text": "Use school resources. Go to the school’s copy room, make copies of the flyer, and take markers and a box of stickers."
							},
							"label": "Option 2"
						}
					],
					"count": 9,
					"setup": "Jane is a first-grade teacher who frequently spends her own money on classroom supplies to support her students. As a result, she sometimes feels frustrated about the personal financial burden of teaching.\n\nJane is preparing for a personal garage sale and needs materials to advertise the event and label items with prices. While planning, she considers whether to use supplies from the school copy room, such as paper, markers, and stickers, since they are readily available and she has already spent so much of her own money on classroom needs.",
					"title": "Situation 6: School Supplies",
					"number": 6,
					"prompt": "What should Jane do?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following two flip cards to learn about the possible options for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 13,
				"sourceId": 5130
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37091,
					"label": "Module 5: The Professional Educator and the Community",
					"title": "Module 5: The Professional Educator and the Community",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103714,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "Review the ethical principles to determine whether each ethical principle was at immediate risk by the educators in the scenario.",
				"items": [
					{
						"back": {
							"selected": false,
							"riskLevel": "Not At Immediate Risk",
							"explanation": ""
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-01-promoting-solution-discovery-illustration-v2.png"
								}
							],
							"title": "Promoting Solution Discovery"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "Not At Immediate Risk",
							"explanation": ""
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-02-risk-mitigation-illustration-v2.png"
								}
							],
							"title": "Risk Mitigation"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "By repeating hearsay and implying it as fact, Coach Wong failed to remain unbiased and contributed to a culture of speculation."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-03-objectivity-neutrality-maintained-illustration-v3.png"
								}
							],
							"title": "Objectivity and Neutrality Are Maintained"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Ms. Garcia openly discussed confidential information about a student with disabilities in a public restaurant, risking exposure of protected information, loss of dignity, and emotional harm. This directly jeopardized the student’s welfare because academic and disability-related details are highly sensitive and legally protected."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-04-ensuring-student-welfare-illustration-v2.png"
								}
							],
							"title": "Ensuring Student Welfare"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "Not At Immediate Risk",
							"explanation": ""
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-05-transparency-actions-communications-illustration-v2.png"
								}
							],
							"title": "Transparency in Actions and Communications"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Ms. Garcia treated FERPA-protected information as a topic for casual conversation in a public social space outside school."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-06-boundaries-role-time-place-illustration-v2.png"
								}
							],
							"title": "Honoring the Boundaries of Role, Time, and Place"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Coach Wong repeated a rumor about a colleague in public, which directly undermines trust, professionalism, and collegial respect. This behavior risks harming another educator’s reputation and the public’s trust in the profession."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-07-integrity-profession-illustration-v2.png"
								}
							],
							"title": "Integrity of the Profession Is Promoted by the Educator"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Inaction in the face of ethically questionable behavior by one’s peers can unintentionally normalize it. Mr. Anderson sensed this risk but chose to remain silent instead of acting on his concerns."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-08-code-ethics-fidelity-illustration-v2.png"
								}
							],
							"title": "Code of Ethics for Educators Is Maintained with Fidelity"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Although Mr. Anderson did not disclose information himself, he stayed at the table while FERPA-sensitive and rumor-based conversations occurred. Since it was possible for the conversation to be overheard, his failure to act when he recognized a boundary violation could erode public trust and indirectly contribute to misconduct."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-09-stewardship-law-public-trust-illustration-v2.png"
								}
							],
							"title": "Stewardship of the Law and Public Trust"
						}
					}
				],
				"title": "Scenario: Review",
				"instruction": "**Directions:** Select each of the following nine flip cards to explore whether each ethical principle was at immediate risk for Coach Wong, Mr. Anderson, and Ms. Garcia in the scenario. Each of the nine cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_principle_review_cards",
				"language": "en-US",
				"position": 6,
				"sourceId": 5060
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37091,
					"label": "Module 5: The Professional Educator and the Community",
					"title": "Module 5: The Professional Educator and the Community",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103715,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of nine situations that require you to choose from two alternate responses to the situation. After each situation, you will be presented with two flip cards that describe a response to the situation. Take a moment to consider the ethical implications and think about how you would handle each situation.",
				"title": "Ethical Situations: What Action Is Appropriate?",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Good job. This approach respects student privacy, involves families in the decision, and ensures that personal information is shared only with permission and for a clear educational purpose."
							},
							"front": {
								"text": "Notify parents or guardians of the intent of the study-partner program and ask each of them for explicit permission to include their child’s name and appropriate contact information on a contact list."
							},
							"label": "Option 1"
						},
						{
							"id": "B",
							"back": {
								"text": "Try again. A student’s personal contact information and their level of performance in the class are confidential. It is up to parents or guardians to decide whether and when to consent to the risks that come with sharing their child’s contact information. Additionally, revealing a student’s strengths and weaknesses to the rest of the class may intimidate or embarrass the student."
							},
							"front": {
								"text": "Pass a sheet of paper around the classroom that lists each student’s cell phone number, their email address, and a note about their strengths and weaknesses in math."
							},
							"label": "Option 2"
						}
					],
					"count": 9,
					"setup": "Kylie, a middle school mathematics teacher, wants to set up a study-partner program among students.",
					"title": "Situation 2: Study Program",
					"number": 2,
					"prompt": "What should Kylie do?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following two flip cards to learn about the possible options for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 9,
				"sourceId": 5090
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37091,
					"label": "Module 5: The Professional Educator and the Community",
					"title": "Module 5: The Professional Educator and the Community",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103716,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of nine situations that require you to choose from two alternate responses to the situation. After each situation, you will be presented with two flip cards that describe a response to the situation. Take a moment to consider the ethical implications and think about how you would handle each situation.",
				"title": "Ethical Situations: What Action Is Appropriate?",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Try again. If Amelia publicly complained about her students on social media, she would be acting unprofessionally, be risking damage to her professional relationships, and be potentially disclosing confidential information. Instead, she should address concerns constructively with her supervisor."
							},
							"front": {
								"text": "Post a comment on her personal social media page, such as “Why did they load up MY class with special ed kids? Help!”"
							},
							"label": "Option 1"
						},
						{
							"id": "B",
							"back": {
								"text": "Good job. This is the constructive and appropriate way for Amelia to address her concerns. She should not complain publicly or reveal confidential information about students."
							},
							"front": {
								"text": "Express her specific concerns to her immediate supervisor and ask for additional clarification on how students with learning disabilities are placed in and prepared for inclusion in traditional classes."
							},
							"label": "Option 2"
						}
					],
					"count": 9,
					"setup": "Amelia, a high school teacher, is upset because there are many students with learning disabilities in her sixth-period class. She wants to change things.",
					"title": "Situation 3: How to Express Concerns",
					"number": 3,
					"prompt": "What should Amelia do?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following two flip cards to learn about the possible options for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 10,
				"sourceId": 5100
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37091,
					"label": "Module 5: The Professional Educator and the Community",
					"title": "Module 5: The Professional Educator and the Community",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103717,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of nine situations that require you to choose from two alternate responses to the situation. After each situation, you will be presented with two flip cards that describe a response to the situation. Take a moment to consider the ethical implications and think about how you would handle each situation.",
				"title": "Ethical Situations: What Action Is Appropriate?",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Good job. School policy and procedures provide the proper protocol and protect the educator from exposure to risks. A desire to help a good cause does not reduce the professional risks to Kelly if she does not follow procedures."
							},
							"front": {
								"text": "Prior to loaning the equipment, determine and follow the administration’s policy and procedures for loaning out such equipment."
							},
							"label": "Option 1"
						},
						{
							"id": "B",
							"back": {
								"text": "Try again. A desire to help a good cause does not relieve an educator from the responsibility to follow proper protocol, nor does the good cause reduce the professional risks, like liability for damage, if Kelly does not follow procedures."
							},
							"front": {
								"text": "Loan out the equipment without checking the school’s policy. Helping to support a community event is a good idea. Just make sure the equipment is accounted for."
							},
							"label": "Option 2"
						}
					],
					"count": 9,
					"setup": "A close friend approaches Kelly, the school’s physical education teacher, about borrowing the school’s track equipment for an upcoming charity race that supports a local cancer treatment facility.",
					"title": "Situation 5: School Property",
					"number": 5,
					"prompt": "What should Kelly do?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following two flip cards to learn about the possible options for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 12,
				"sourceId": 5120
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37091,
					"label": "Module 5: The Professional Educator and the Community",
					"title": "Module 5: The Professional Educator and the Community",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103718,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of nine situations that require you to choose from two alternate responses to the situation. After each situation, you will be presented with two flip cards that describe a response to the situation. Take a moment to consider the ethical implications and think about how you would handle each situation.",
				"title": "Ethical Situations: What Action Is Appropriate?",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Try again. Mario should submit a careful account of only the charges he would have incurred if he was traveling by himself and pay personally for all other charges. It is unprofessional, and a misuse of public funds, to have the school pay for his family’s expenses and other nonreimbursable items."
							},
							"front": {
								"text": "Submit all his credit card charges for those two days to the school district for reimbursement."
							},
							"label": "Option 1"
						},
						{
							"id": "B",
							"back": {
								"text": "Good job. In this way, Mario is following policy and is also acting as a steward of public funds."
							},
							"front": {
								"text": "Carefully document the charges he would have incurred if he were traveling by himself and submit only those charges for reimbursement as permitted by his school and district policies."
							},
							"label": "Option 2"
						}
					],
					"count": 9,
					"setup": "Mario, a mathematics department head, travels across the state to attend a two-day mathematics conference at a popular resort. His family travels with him, and he charges their hotel room, their dinners, and tickets to a show to his personal credit card.",
					"title": "Situation 7: School Expenses",
					"number": 7,
					"prompt": "What should Mario do?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following two flip cards to learn about the possible options for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 14,
				"sourceId": 5140
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37091,
					"label": "Module 5: The Professional Educator and the Community",
					"title": "Module 5: The Professional Educator and the Community",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103719,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of nine situations that require you to choose from two alternate responses to the situation. After each situation, you will be presented with two flip cards that describe a response to the situation. Take a moment to consider the ethical implications and think about how you would handle each situation.",
				"title": "Ethical Situations: What Action Is Appropriate?",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Try again. Mixing school funds with personal money is inappropriate and lacks transparency. Educators must follow school policies, document all payments and expenditures, and keep school funds separate to ensure accountability."
							},
							"front": {
								"text": "Place it, along with extra cash of his own that he has been carrying, in a locked box and then lock that box in a classroom file cabinet. Now the money is safe and double locked."
							},
							"label": "Option 1"
						},
						{
							"id": "B",
							"back": {
								"text": "Good job. When receiving and handling school funds, educators must carefully follow all school policies and procedures, document every receipt and expenditure, and keep the school’s money separate from their own."
							},
							"front": {
								"text": "Log every payment as he receives it and give each donor a receipt. He should keep the money separate from his personal funds and submit the money to the school’s fiscal officer that same day."
							},
							"label": "Option 2"
						}
					],
					"count": 9,
					"setup": "Douglas, a high school teacher who is responsible for the school band’s booster event, collects over $2,000 in one day, mostly in cash. He is concerned about the security of the money.",
					"title": "Situation 4: School Funds",
					"number": 4,
					"prompt": "What should Douglas do?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following two flip cards to learn about the possible options for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 11,
				"sourceId": 5110
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37091,
					"label": "Module 5: The Professional Educator and the Community",
					"title": "Module 5: The Professional Educator and the Community",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103720,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"stem": {
					"text": "Which of the following is the clearest example of a teacher acting inappropriately in a public setting?"
				},
				"title": "Knowledge Check Question 1"
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "knowledge_check_question",
				"language": "en-US",
				"position": 18,
				"sourceId": 5180
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "cd5697bc-2f58-4134-b255-21c529a21331",
						"isCorrect": false
					},
					{
						"choiceId": "abb4d96c-42e1-4368-ac64-14c747945582",
						"isCorrect": false
					},
					{
						"choiceId": "5d1f3266-5fd1-4cc6-acf2-c52803cdd2db",
						"isCorrect": true
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "5d1f3266-5fd1-4cc6-acf2-c52803cdd2db",
					"detailed": {
						"text": "It is unprofessional and inappropriate for a teacher to discuss issues involving a student with someone who has no role in the student's education. It is worse that this teacher's discussion was loud and held in a public place where others could overhear the comments."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "cd5697bc-2f58-4134-b255-21c529a21331",
						"text": "While eating at a local restaurant, a teacher notices a group of students and asks to be seated away from them.",
						"numFirstSelections": 0
					},
					{
						"id": "abb4d96c-42e1-4368-ac64-14c747945582",
						"text": "While out for a walk, a teacher sees a student and the student’s mother and greets the mother first.",
						"numFirstSelections": 0
					},
					{
						"id": "5d1f3266-5fd1-4cc6-acf2-c52803cdd2db",
						"text": "While at a local athletic event, a teacher complains loudly about a student to a friend.",
						"numFirstSelections": 0
					}
				],
				"shuffle": false,
				"instruction": "Choose the best answer from the following options."
			},
			"tags": [
				{
					"id": 37091,
					"label": "Module 5: The Professional Educator and the Community",
					"title": "Module 5: The Professional Educator and the Community",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103721,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"stem": {
					"text": "Following the suspension of a classmate, students question their teacher, Ms. King, about the cause of the suspension. The school district has not yet made public the suspension or the circumstances behind it.\n\nWhich of the following responses by Ms. King is most appropriate in this case?"
				},
				"title": "Knowledge Check Question 3"
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "knowledge_check_question",
				"language": "en-US",
				"position": 20,
				"sourceId": 5200
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "9f7ec775-d330-46ac-ba49-8e7715d9f894",
						"isCorrect": true
					},
					{
						"choiceId": "fd9ccd30-07fe-4ec5-9c1d-b4118b256457",
						"isCorrect": false
					},
					{
						"choiceId": "a8368ba3-1595-4ae5-9715-53354d378d4a",
						"isCorrect": false
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "9f7ec775-d330-46ac-ba49-8e7715d9f894",
					"detailed": {
						"text": "Student disciplinary records are generally kept confidential, and in this instance, the school district has not yet found cause or grounds to do otherwise. Ms. King therefore cannot appropriately breach that confidentiality with her students."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "9f7ec775-d330-46ac-ba49-8e7715d9f894",
						"text": "Ms. King should not discuss the matter because it would violate the suspended student’s right of confidentiality.",
						"numFirstSelections": 0
					},
					{
						"id": "fd9ccd30-07fe-4ec5-9c1d-b4118b256457",
						"text": "Ms. King should discuss the matter openly and use the incident as a teaching opportunity.",
						"numFirstSelections": 0
					},
					{
						"id": "a8368ba3-1595-4ae5-9715-53354d378d4a",
						"text": "Ms. King should only discuss the matter after getting permission from the principal.",
						"numFirstSelections": 0
					}
				],
				"shuffle": false,
				"instruction": "Choose the best answer from the following options."
			},
			"tags": [
				{
					"id": 37091,
					"label": "Module 5: The Professional Educator and the Community",
					"title": "Module 5: The Professional Educator and the Community",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103722,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"stem": {
					"text": "Mr. Cho, a teacher, sees a fellow teacher from his school using illicit drugs in a bathroom at a local bar, and he decides not to report the incident.\n\nWhich of the following best explains whether Mr. Cho acted in a manner consistent with the behavior of a professional educator?"
				},
				"title": "Knowledge Check Question 5"
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "knowledge_check_question",
				"language": "en-US",
				"position": 22,
				"sourceId": 5220
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "da587e5e-49d1-4f0f-9f52-e04eda1cf99d",
						"isCorrect": false
					},
					{
						"choiceId": "5a9c147e-4ccc-4380-ba72-510e860e6a56",
						"isCorrect": false
					},
					{
						"choiceId": "2ad8d602-842f-4d49-95a0-ab2fc52fe5c8",
						"isCorrect": true
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "2ad8d602-842f-4d49-95a0-ab2fc52fe5c8",
					"detailed": {
						"text": "Even though the incident occurred outside of school, Mr. Cho has a professional responsibility to act when he is aware of potential illegal or unethical behavior by another educator. Educators are expected to uphold the law and protect the integrity of the profession. Ignoring the situation allows potential harm to continue and undermines public trust."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "da587e5e-49d1-4f0f-9f52-e04eda1cf99d",
						"text": "The incident took place outside of school hours, so Mr. Cho has no duty to report it.",
						"numFirstSelections": 0
					},
					{
						"id": "5a9c147e-4ccc-4380-ba72-510e860e6a56",
						"text": "No one else from the school witnessed the incident, so reporting it will make no difference.",
						"numFirstSelections": 0
					},
					{
						"id": "2ad8d602-842f-4d49-95a0-ab2fc52fe5c8",
						"text": "Mr. Cho has knowledge of a statutory violation, so he is obligated to report it.",
						"numFirstSelections": 0
					}
				],
				"shuffle": false,
				"instruction": "Choose the best answer from the following options."
			},
			"tags": [
				{
					"id": 37091,
					"label": "Module 5: The Professional Educator and the Community",
					"title": "Module 5: The Professional Educator and the Community",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103723,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of nine situations that require you to choose from two alternate responses to the situation. After each situation, you will be presented with two flip cards that describe a response to the situation. Take a moment to consider the ethical implications and think about how you would handle each situation.",
				"title": "Ethical Situations: What Action Is Appropriate?",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Try again. Meeting with a student outside school can risk Denny’s professional reputation and blurs professional boundaries. If it must happen, Denny should obtain supervisor approval and ensure another adult, such as Michelle’s parent or a faculty adviser, is present."
							},
							"front": {
								"text": "Accept Michelle’s suggestion that they meet at a local coffee shop on Saturday."
							},
							"label": "Option 1"
						},
						{
							"id": "B",
							"back": {
								"text": "Good job. This minimizes professional risk and prevents any appearance of impropriety. If a weekend meeting is unavoidable, Denny should seek supervisor approval and have another adult present."
							},
							"front": {
								"text": "Avoid meeting on weekends and outside school settings."
							},
							"label": "Option 2"
						}
					],
					"count": 9,
					"setup": "Denny is a young high school teacher. A student, Michelle, is the president of a service club for which Denny is the faculty adviser. Michelle is now eighteen and about to graduate. Michelle requests to meet Denny over the weekend to go over final plans for an end-of-year event that the service club is running.",
					"title": "Situation 9: Appearances",
					"number": 9,
					"prompt": "What should Denny do?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following two flip cards to learn about the possible options for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 16,
				"sourceId": 5160
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37091,
					"label": "Module 5: The Professional Educator and the Community",
					"title": "Module 5: The Professional Educator and the Community",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103724,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"stem": {
					"text": "Which of the following actions by a professional educator best demonstrates promoting the profession and avoiding the appearance of impropriety?"
				},
				"title": "Knowledge Check Question 2"
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "knowledge_check_question",
				"language": "en-US",
				"position": 19,
				"sourceId": 5190
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "3683306a-8afa-4984-8993-cc34ca231200",
						"isCorrect": true
					},
					{
						"choiceId": "97875f3d-c342-4b79-bb64-5190bdfdaa8e",
						"isCorrect": false
					},
					{
						"choiceId": "69e641a5-81b0-4b7e-b092-9bc45220c30c",
						"isCorrect": false
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "3683306a-8afa-4984-8993-cc34ca231200",
					"detailed": {
						"text": "Using school-approved communication channels helps ensure that interactions with students are transparent, appropriate, and professionally monitored. This protects both the educator and the student and supports trust in the profession. This practice aligns with expectations to promote the profession and avoid the appearance of impropriety."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "3683306a-8afa-4984-8993-cc34ca231200",
						"text": "A teacher interacts with students through school-approved communication channels only.",
						"numFirstSelections": 0
					},
					{
						"id": "97875f3d-c342-4b79-bb64-5190bdfdaa8e",
						"text": "A teacher accepts a small personal favor from a student’s family to help strengthen the home–school relationship.",
						"numFirstSelections": 0
					},
					{
						"id": "69e641a5-81b0-4b7e-b092-9bc45220c30c",
						"text": "A teacher shares informal opinions about students with personal friends outside of school to seek advice.",
						"numFirstSelections": 0
					}
				],
				"shuffle": false,
				"instruction": "Choose the best answer from the following options."
			},
			"tags": [
				{
					"id": 37091,
					"label": "Module 5: The Professional Educator and the Community",
					"title": "Module 5: The Professional Educator and the Community",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103725,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"stem": {
					"text": "During the first few weeks of teaching a sixth-grade class, Ms. Wayne is having difficulty dealing with Bert, a disruptive student. After checking Bert’s Individualized Education Program (IEP), Ms. Wayne still does not understand why he is being disruptive.\n\nWhich of the following steps would most put the ethical principles for professional educators at risk?"
				},
				"title": "Knowledge Check Question 4"
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "knowledge_check_question",
				"language": "en-US",
				"position": 21,
				"sourceId": 5210
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "e4bc4e83-b94d-4d89-8a55-a4396afd2763",
						"isCorrect": false
					},
					{
						"choiceId": "14f59d0d-9ff1-4e4d-9f2a-7a33293bfde3",
						"isCorrect": true
					},
					{
						"choiceId": "c6181274-ea29-4e1c-ba0f-e74476c8d535",
						"isCorrect": false
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "14f59d0d-9ff1-4e4d-9f2a-7a33293bfde3",
					"detailed": {
						"text": "The nature of a student’s disabilities is confidential, even if the student has an Individualized Education Program (IEP). Therefore, an educator should share such information only with a student’s parents or with other educators involved in the student’s program. It is inappropriate to discuss a student’s disabilities or difficulties with other students."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "e4bc4e83-b94d-4d89-8a55-a4396afd2763",
						"text": "Ms. Wayne contacts Bert’s mother to inform her about his behavior and discuss the IEP in more detail.",
						"numFirstSelections": 0
					},
					{
						"id": "14f59d0d-9ff1-4e4d-9f2a-7a33293bfde3",
						"text": "Ms. Wayne asks three of Bert’s friends if they have seen him act this way in previous years and how their teachers in the past dealt with the issues described in his IEP.",
						"numFirstSelections": 0
					},
					{
						"id": "c6181274-ea29-4e1c-ba0f-e74476c8d535",
						"text": "Ms. Wayne writes a few paragraphs describing Bert’s behavior and submits them to be added to his IEP progress report so that other teachers will have access to more information about him.",
						"numFirstSelections": 0
					}
				],
				"shuffle": false,
				"instruction": "Choose the best answer from the following options."
			},
			"tags": [
				{
					"id": 37091,
					"label": "Module 5: The Professional Educator and the Community",
					"title": "Module 5: The Professional Educator and the Community",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103726,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "**Why Ethical Judgment Matters in Everyday Situations**\n\nThe scenario you explored highlights how quickly professional boundaries can erode when educators are in casual, social environments. Although the teachers were “off the clock,” their words and actions still carried professional weight and had real consequences. Conversations that may feel harmless in the moment can violate legal protections, undermine trust from families, damage collegial relationships, and diminish the public’s confidence in the profession.\n\n**Key Ethical Standards Addressed in This Module**\n\nThe scenario highlights several core ethical responsibilities that educators must uphold in all settings.\n\n- **Student confidentiality is essential.**\nDiscussing a student’s disabilities, academic struggles, or accommodations in public violates privacy expectations and legal protections such as FERPA, particularly when others may overhear.\n\n- **Professional boundaries related to role, time and place extend beyond the school building.**\n\nDiscussing confidential student matters or staff conflicts in social settings breaches those boundaries. The integrity of the profession depends on educators’ everyday actions, since casual disclosures, gossip, and boundary violations can weaken public confidence in education.\n\n- **Educators have a responsibility to act when ethical standards are at risk.**\n\nRemaining silent in the face of misconduct allows harm to continue and signals acceptance, even when the educator is not directly involved.\n\n**Applying Ethical Decision Making in Your Own Practice**\n\nThis module emphasizes that ethical decision making is not a one-time event but a daily practice informed by dispositions, professional judgment, and awareness of legal and ethical frameworks. To uphold the standards of the profession, the following guidelines should be followed.\n\n- Pause to reflect before acting during emotionally charged or casual moments.\n- Reflect on whether your decision aligns with both dispositional values and regulatory obligations.\n- Protect student welfare, including emotional well-being, dignity, and privacy.\n- Maintain objectivity and neutrality by avoiding gossip, by not making unwarranted assumptions, and by not allowing personal biases to affect your decisions.\n- Set and reinforce boundaries that preserve professionalism in all environments.\n- Intervene or redirect when colleagues’ actions risk harming students, peers, or the integrity of the profession.\n- By using the guidelines in the *Model Code of Ethics for Educators*, particularly the principles related to student welfare, professional conduct, confidentiality, and stewardship of the law and public trust, to inform everyday actions, educators uphold a standard of excellence that supports safe, respectful, and trustworthy learning communities.",
				"title": "Module 5 Summary"
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "module_summary",
				"language": "en-US",
				"position": 17,
				"sourceId": 5170
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37091,
					"label": "Module 5: The Professional Educator and the Community",
					"title": "Module 5: The Professional Educator and the Community",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		}
	],
	"examName": "Module 5: The Professional Educator and the Community",
	"sessionSubType": "PRACTICE_TEST",
	"publicId": "83a36028-bb93-4415-9d53-62bb0975141d",
	"sessionType": "SUMMATIVE",
	"totalTime": null
}
